<template>
  <!-- 适老化改造 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="listData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      :permission="permissionList"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <el-button
          v-if="permissionList.addBtn"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="openDialog('add')"
        >
          新增
        </el-button>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button
          v-if="permissionList.viewBtn"
          type="text"
          size="small"
          @click="openDialog('view', row)"
        >
          查看
        </el-button>
        <el-button
          v-if="permissionList.editBtn"
          type="text"
          size="small"
          @click="openDialog('edit', row)"
        >
          编辑
        </el-button>
        <el-button
          v-if="permissionList.delBtn && row.fileStatus == '3'"
          type="text"
          size="small"
          @click="doOperation('del', row)"
        >
          删除
        </el-button>
        <el-button
          v-if="permissionList.cancelBtn && row.fileStatus != '3'"
          type="text"
          size="small"
          @click="doOperation('cancel', row)"
        >
          取消
        </el-button>
        <el-button
          v-if="permissionList.startBtn && row.fileStatus == '2'"
          type="text"
          size="small"
          @click="doOperation('start', row)"
        >
          开工
        </el-button>
        <el-button
          v-if="permissionList.finishBtn && row.fileStatus == '4'"
          type="text"
          size="small"
          @click="doOperation('finish', row)"
        >
          完工
        </el-button>
      </template>
    </avue-crud>
    <!-- 弹框 -->
    <el-dialog
      :title="dialogTitle"
      width="80%"
      :visible.sync="isDialogShow"
      :before-close="beforeCloseDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <Form
        v-if="isDialogShow && ['add', 'edit', 'view'].includes(dialogType)"
        :dialogType="dialogType"
        :nursinghomeId="searchForm.nursinghomeId"
        :rowData="rowData"
        @update="updateTableDataSuccess"
        @close="beforeCloseDialog"
      ></Form>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Form from './reformForm';
import { getNursinghomeList } from '../api/public.js';
import { getPageListApi, removeApi, cancelApi, startApi, finishApi } from '../api/reform';

export default {
  components: {
    Form,
  },
  data() {
    return {
      oldNursinghomeId: '', // 旧养老院id，重置搜索条件和新增时需要使用
      nursinghomeList: [], // 养老院列表
      searchForm: {}, // 搜索表单
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      listData: [], // 列表数据
      loading: false,
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 数据的表格展示配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        index: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        searchMenuSpan: 12,
        searchLabelWidth: 100,
        column: [
          {
            label: '服务网点',
            prop: 'nursinghomeId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            disabled: true,
            search: true,
            searchClearable: false,
            rules: [
              {
                required: true,
                message: '请选择服务网点',
                trigger: 'change',
              },
            ],
          },
          {
            label: '老人姓名',
            prop: 'elderlyName',
            width: 100,
            maxlength: '10',
            showWordLimit: true,
          },
          {
            label: '签订业主姓名',
            prop: 'personName',
            width: 100,
            maxlength: '10',
            showWordLimit: true,
            search: true,
          },
          {
            label: '签订日期',
            prop: 'signTime',
            width: 120,
            type: 'date',
            format: 'yyyy-MM-dd',
          },
          {
            label: '家庭地址',
            prop: 'domicileAddress',
            width: 140,
            overHidden: true,
          },
          {
            label: '详细地址',
            prop: 'address',
            width: 140,
            overHidden: true,
          },
          {
            label: '签订业主电话',
            prop: 'tel',
            width: 120,
          },
          {
            label: '签订业主与老人关系',
            prop: 'relationship',
            width: 140,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=elderly_relationship',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '改造金额(元)',
            prop: 'modifierAmount',
            width: 120,
          },
          {
            label: '档案状态',
            prop: 'fileStatus',
            width: 100,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=elderly_file_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            search: true,
          },
          {
            label: '缴费状态',
            prop: 'paymentStatus',
            width: 100,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=elderly_payment_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            search: true,
          },
          {
            label: '资料状态',
            prop: 'dataStatus',
            width: 100,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=elderly_data_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            search: true,
          },
          {
            label: '扫描状态',
            prop: 'scanningStatus',
            width: 100,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=elderly_scanning_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '公示状态',
            prop: 'publicStatus',
            width: 100,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=elderly_public_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            search: true,
          },
          {
            label: '备注',
            prop: 'remark',
            overHidden: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.elder_reform_add, false),
        delBtn: this.vaildData(this.permission.elder_reform_del, false),
        editBtn: this.vaildData(this.permission.elder_reform_edit, false),
        viewBtn: this.vaildData(this.permission.elder_reform_view, false),
        cancelBtn: this.vaildData(this.permission.elder_reform_cancel, false),
        startBtn: this.vaildData(this.permission.elder_reform_start, false),
        finishBtn: this.vaildData(this.permission.elder_reform_finish, false),
      };
    },
  },
  created() {
    getNursinghomeList().then(({ data }) => {
      this.nursinghomeList = data || [];
      if (this.nursinghomeList.length > 0) {
        this.findObject(this.tableOption.column, 'nursinghomeId').dicData = this.nursinghomeList;
        this.searchForm.nursinghomeId = this.nursinghomeList[0].id;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 400; // 表格区域初始化高度
      const searchH = 110; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    loadData(page) {
      if (this.nursinghomeList.length == 0) return; // 在获取到养老院列表前不要请求列表
      this.oldNursinghomeId = this.searchForm.nursinghomeId;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.listData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {
        nursinghomeId: this.oldNursinghomeId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 表格数据更新成功 */
    updateTableDataSuccess() {
      this.loadData();
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 删除/取消/开工/完工 */
    doOperation(type, row) {
      const mapInfo = {
        del: { title: '确认删除该适老化申请记录吗？', fn: removeApi, key: 'ids' },
        cancel: { title: '确认取消该适老化改造申请？', fn: cancelApi, key: 'id' },
        start: { title: '确认开工？', fn: startApi, key: 'id' },
        finish: { title: '确认完工？', fn: finishApi, key: 'id' },
      };
      const curr = mapInfo[type] || null;
      if (!curr) return;
      this.$confirm(curr.title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return curr.fn({ [curr.key]: row.id });
        })
        .then(() => {
          this.loadData();
          this.$message.success('操作成功!');
        });
    },
    /* 打开弹框 */
    openDialog(type, rowData = {}) {
      let titles = {
        add: '新增',
        edit: '编辑',
        view: '查看',
      };
      this.dialogTitle = titles[type];
      this.dialogType = type;
      this.rowData = rowData;
      if (type === 'view') {
        this.needCloseConfirm = false;
      } else {
        this.needCloseConfirm = true;
      }
      this.isDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseDialog(done) {
      if (!this.needCloseConfirm) {
        this.closeDialog();
        if (typeof done == 'function') {
          done();
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.closeDialog();
            if (typeof done == 'function') {
              done();
            }
          })
          .catch(() => {});
      }
    },
    /* 直接关闭弹框 */
    closeDialog() {
      this.dialogType = '';
      this.isDialogShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
